import { Modal } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { MedicationsEntity, LabTestsEntityOrProceduresEntity, InjectionsEntity } from '../../../../../store/types/prescription';
import { LAB_TESTS_KIND } from '../../../trackSource';
import PrescribeAutoSuggestV2 from '../PrescribeAutoSuggestV2';

type Props = {
    closeMe: () => void;
    visible?: boolean;
    onSelect: (drug: MedicationsEntity | LabTestsEntityOrProceduresEntity | InjectionsEntity) => void;
};

class AddCustomLabTestModal extends PureComponent<Props> {
    render(): ReactNode {
        const { closeMe, visible, onSelect } = this.props;

        return (
            <Modal
                bodyStyle={{
                    padding: '0px',
                }}
                title={
                    <div className="flex items-center justify-between text-darwin-neutral-900 w-full">
                        <p className="font-700">Add Lab Investigation</p>
                        <svg
                            className="w-14 h-14 fill-darwin-neutral-900"
                            viewBox="0 0 12 12"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={closeMe}
                        >
                            <path d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z" />
                        </svg>
                    </div>
                }
                visible={visible}
                width={550}
                onCancel={closeMe}
                footer={null}
                closable={false}
                destroyOnClose
            >
                <div className="px-20 py-16 h-420 overflow-scroll">
                    <PrescribeAutoSuggestV2
                        kind={LAB_TESTS_KIND}
                        onSelect={onSelect}
                        hideVendorPackages
                    />
                </div>
            </Modal>
        );
    }
}

export default AddCustomLabTestModal;
